import { characters } from '@/mocks/characters';
import CharacterCard from '@/components/base/CharacterCard';

export default function CharacterSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            主要角色一览
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 font-body max-w-xl mx-auto">
            深入了解亲吻姐姐中每位角色的魅力与故事
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {characters.map((char) => (
            <CharacterCard key={char.slug} character={char} />
          ))}
        </div>
      </div>
    </section>
  );
}